var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDragAndDrop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_drag_and_drop",
    d: "M22.125,3.75A3.754,3.754,0,0,0,18.375,0H3.75A3.754,3.754,0,0,0,0,3.75V18.375a3.754,3.754,0,0,0,3.75,3.75h6v2.5h2.5v-2.5h6.125a3.754,3.754,0,0,0,3.75-3.75v-6h2.438v-2.5H22.125Zm-2.5,14.625a1.251,1.251,0,0,1-1.25,1.25H3.75a1.251,1.251,0,0,1-1.25-1.25V3.75A1.251,1.251,0,0,1,3.75,2.5H18.375a1.251,1.251,0,0,1,1.25,1.25ZM29.5,27H32v2.5A2.5,2.5,0,0,1,29.5,32H27.063V29.5H29.5ZM17.063,29.5h2.5V32h-2.5Zm5,0h2.5V32h-2.5ZM32,12.375v2.5H29.5v-2.5H27.063v-2.5H29.5A2.5,2.5,0,0,1,32,12.375ZM29.5,17.25H32v2.5H29.5Zm0,4.875H32v2.5H29.5ZM12.25,29.5h2.438V32H12.25a2.5,2.5,0,0,1-2.5-2.5V27h2.5ZM14.563,9.625h2.5v7.5h-7.5v-2.5h3.232l-4.46-4.46L10.1,8.4l4.46,4.46Zm0,0",
    transform: "rotate(180 16 16)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDragAndDrop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_drag_and_drop.b1f402b3ed6d6ea9054733225b22eaec.svg";